import map from 'lodash/map'
import React, { useContext, useEffect, useState } from 'react'

import { ProductTileWrapper } from '@Components/ProductList/ProductTileWrapper'
import wrapperStyles from '@Components/ProductList/ProductTileWrapper.module.scss'
import { InjectionSlots } from '@Components/ProductList/Slots/Client'
import { ProductTile } from '@Domains/Product/Tiles/Tile'
import { ProductTileGrouped } from '@Domains/Product/Tiles/TileGrouped'
import { ProductSearchContext } from '@Globals/Algolia/Context'
import { MetadataContext } from '@Globals/Metadata'
import { useSplitTest } from '@Globals/SplitTests/Hooks'
import { useMediaQuery } from '@Globals/useMediaQuery'

export const ProductTilesList = ({
  scrollToTop,
}: {
  scrollToTop?: () => void
}) => {
  const { storeURL } = useContext(MetadataContext)
  const { hitsArray } = useContext(ProductSearchContext)
  // b and c render the grouped tile; its taller bottom content (thumbnail
  // row, brand line) needs the wrapper class raising the tile aspect so the
  // image area keeps its size
  const groupedProductsGroup = useSplitTest('grouped_products_v2')
  const groupThumbnails = groupedProductsGroup === 'b' || groupedProductsGroup === 'c'
  // control (a) defers hover-image DOM to desktop via this media query, at
  // the cost of a full list rerender when it settles after mount. The
  // grouped tile skips that entirely (hover images gate on actual pointer
  // interaction inside the tile instead): the never-matching query keeps
  // the hook inert — its state stays false, so no post-mount rerender fires.
  const isDesktop = useMediaQuery(groupThumbnails ? '(min-width: 999999px)' : '(min-width: 1024px)')
  const [enableHover, setEnableHover] = useState(false)

  useEffect(() => { setEnableHover(isDesktop) }, [isDesktop])

  return (
    <ProductTileWrapper className={groupThumbnails ? wrapperStyles.groupThumbsAspect : undefined} maxColumns={4}>
      {map(hitsArray, (ref, index: number) => (groupThumbnails
        ? (
          <ProductTileGrouped
            key={ref.id}
            {...ref}
            enableHover
            // sibling tiles carry raw slugs; prefix them like the parent url
            groupedTiles={ref.groupedTiles?.map(entry => (entry.tile
              ? { ...entry, tile: { ...entry.tile, url: storeURL(entry.tile.url) } }
              : entry))}
            priority={index < 12}
            sourceID="product_list"
            tileIndex={index + 1}
            url={storeURL(ref.url)}
          />
        )
        : (
          <ProductTile
            key={ref.id}
            {...ref}
            enableHover={enableHover}
            priority={index < 12}
            sourceID="product_list"
            tileIndex={index + 1}
            url={storeURL(ref.url)}
          />
        )))}
      <InjectionSlots scrollToTop={scrollToTop} />
    </ProductTileWrapper>
  )
}
